import Vue from 'vue'
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
Sentry.init({
    Vue,
    dsn: "https://695f1bede9fb44bbb927e892dfb0626d@o353488.ingest.sentry.io/5511589",
    integrations: [
        new Integrations.BrowserTracing(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import router from './router.js'
import 'es7-object-polyfill'
import 'fetch-polyfill'
import 'babel-polyfill'
import VueLocalStorage from 'vue-localstorage'
import App from './App.vue'
import VueApollo from 'vue-apollo'
import VeeValidate from 'vee-validate'
import VueHead from 'vue-head'
import VueChartkick from 'vue-chartkick'
// import Chart from 'chart.js'
import VueSwiper from 'vue-awesome-swiper'
import wysiwyg from 'vue-wysiwyg'
import VueCkeditor from 'vue-ckeditor2'
import Highcharts from 'highcharts'
import VueAnalytics from 'vue-analytics'

import AppSyncVT from './components/AppSyncVT.js'

import store from '@/store'

import './assets/stylus/main.styl'

// import colors from 'vuetify/es5/util/colors'

const NuVuetifyThemeOptions = {
    theme: {
        'primary': '#2D9CDB',
        'accent': '#B6ACD1',
        'secondary': '#401F68',
        'info': '#5091CD',
        'warning': '#FFC520',
        'error': '#EF553F',
        'success': '#58B947',
        'nu-purple': '#4E2A84',
        'nu-purple-60': '#836EAA',
        'nu-purple-120': '#401F68',
        'nu-purple-30': '#B6ACD1',
        'nu-purple-10': '#E4E0EE',
        'rich-black-80': '#342F2E',
        'rich-black-50': '#716C6B',
        'rich-black-20': '#BBB8B8',
        'rich-black-10': '#D8D6D6',
        'rich-black-1': '#F0F0F0',
        'toggle-active': '#4E2A84',
        'toggle-inactive': '#E4E0EE'
    }
}

Vue.use(Vuetify, NuVuetifyThemeOptions)

// Install the vue plugin
Vue.use(VueApollo)
Vue.use(Vuetify)
Vue.use(VueLocalStorage)
Vue.use(VeeValidate)
Vue.use(VueHead, {
    separator: '-',
    complement: 'Singer Savvy'
})

Highcharts.theme = {
    colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572',
        '#FF9655', '#FFF263', '#6AF9C4'
    ],
    chart: {
        /* backgroundColor: {
                linearGradient: [0, 0, 500, 500],
                stops: [
                    [0, 'rgb(255, 255, 255)'],
                    [1, 'rgb(240, 240, 255)']
                ]
            },
            */
    },
    title: {
        style: {
            color: '#000',
            font: 'bold 16px "Roboto", sans-serif'
        }
    },
    subtitle: {
        style: {
            color: '#666666',
            font: 'bold 12px "Roboto", sans-serif'
        }
    },

    legend: {
        itemStyle: {
            font: '9pt "Roboto", sans-serif',
            color: 'black'
        },
        itemHoverStyle: {
            color: 'gray'
        }
    },
    xAxis: {
        type: 'datetime',
        labels: {
            format: '{value:%b %e, %Y}'
        }
    }

}

// Apply the theme
Highcharts.setOptions(Highcharts.theme)

Vue.use(VueChartkick, { adapter: Highcharts })

Vue.use(VueSwiper)

Vue.use(wysiwyg, {})

Vue.use(VueCkeditor)

Vue.use(VueAnalytics, {
    id: 'UA-121326213-1',
    router
})

/* global NODE_ENV, COMMIT, VERSION, SETTINGS */
console.debug(JSON.stringify({ NODE_ENV, COMMIT, VERSION }));
/* global SETTINGS */
console.debug(JSON.stringify({ SETTINGS }));

new Vue({
    store,
    router,
    render: h => h(App),
    components: { App },
    provide: AppSyncVT.appsyncProvider.provide(),
    template: '<App/>'

}).$mount('#app')

console.log('build', 'ebdd17f6730205a9364d43099839067296749542')



// WEBPACK FOOTER //
// ./src/main.js